import _ from "underscore";

import View from "backdraft-app/src/view";
import { default as template } from "../templates/manage_settings";
import { initListeners } from "../helpers/listeners";
import { clearNotifications } from "../helpers/notifications";
import { defaultErrorFn } from "../helpers/errors";

export default class BaseManageSettings extends View {
  get template() {
    return template;
  }

  constructor(options) {
    super(options);
    this.isNew = options.isNew;
    this.app = options.app;
    this.renderOptions = {};
    this.model = options.model;
    initListeners(this);
  }

  render() {
    var options = _.extend({
      pageTitle: this.pageTitle,
      isNew: this.isNew,
      returnToIntegrationUrl: this.app.config.urlConfig.return_to_integrations
    }, this.renderOptions);

    clearNotifications();
    this.$el.html(this.template(options));
    this.stickit();
  }

  _renderBoxCallout(objectName, objectCount, statusText, objectType) {
    var calloutStatus, calloutIcon, calloutIconColor, boxCallout;

    if (objectType === undefined) {
      objectType = "Campaigns";
    }

    // the number is a string because of how we get the attribute from the model using model.escape
    if (objectCount === "0") {
      calloutStatus = "warning";
      calloutIconColor = "color-warning";
      calloutIcon = "warning";
    } else {
      calloutStatus = "success";
      calloutIconColor = "color-success";
      calloutIcon = "check";
    }

    boxCallout = "<div class='box-callout " + calloutStatus + "'>" +
      "<div class='w-75'>" +
      "<span class='" + calloutStatus + "'><i class='material-icons icon--status " + calloutIconColor + "'>" + calloutIcon + "</i> " + statusText + "</span>" +
      "</div>" +
      "<div class='float-right'>" +
      "<button id='manage-" + objectName.replace(/_/, '-') + "' name='manage_" + objectName + "' class='btn btn-default pull-right'>Specify " + objectType + "</button>" +
      "</div>" +
      "<div class='clear_both'></div>" +
      "</div>";

    this.$("div#manage_objects_container").append(boxCallout);
  }

  _handleSubmitClick(event) {
    event.preventDefault();
    this.model.save({}, {
      success: function(model) {
        this.app.navigateTo(this.app.config.urlConfig.return_to_integrations);
      },
      error: function(model, response, options) {
        defaultErrorFn(model, response, options);
      }
    });
  }

  _handleDeactivateClick(event) {
    var dialog = new this.app.Views.DeactivateIntegrationModal({
      model: this.model,
      modalBody: this.deactivateModalBody
    });
    dialog.render();
    event.preventDefault();
    return this;
  }

  _handleManageSelectionsClick(event, navigatePage) {
    this.app.navigate(navigatePage);
    event.preventDefault();
  }
}
